import React, {FC, useState} from "react";
import {T, useTranslate} from "@tolgee/react";
import FfairModal from "view/components/modal/FfairModal";
import FfairPaper from "view/components/FfairPaper";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import Alert from "view/components/Alert";
import clsx from "clsx";
import useStyles from "./styles";

type Props = {
  onClose: () => void;
  onSubmit: () => Promise<void> | void;
};

const ConfirmModal: FC<Props> = ({onClose, onSubmit}) => {
  const classes = useStyles();
  const {t} = useTranslate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);

  const description = (
    <>
      <b>
        <T keyName="exhibitor.cart.bank_transfer.confirm.notice_title" />
      </b>
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.confirm.recommend_card"
        params={{b: <b />}}
      />
      <br />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.confirm.not_passed"
        params={{b: <b />}}
      />
      <br />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.confirm.onboarding"
        params={{b: <b />}}
      />
      <br />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.confirm.press_confirm"
        params={{b: <b />}}
      />
    </>
  );
  const handleSubmit = async () => {
    setIsSubmitting(true);
    await onSubmit();

    setIsSubmitting(false);
  };

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }
    onClose();
  };
  const handleChangeAcknowledged = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setAcknowledged(checked);
  };
  return (
    <FfairModal open onClose={handleClose}>
      <FfairPaper className={clsx(classes.root)}>
        <Box className={classes.header}>
          <Typography variant="h2" className={classes.title}>
            <T keyName="exhibitor.cart.bank_transfer.confirm.title" />
          </Typography>
        </Box>
        <Alert severity="info">{description}</Alert>
        <Box mt={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={acknowledged}
                color="primary"
                onChange={handleChangeAcknowledged}
                name="acknowledged"
              />
            }
            label={t("exhibitor.cart.bank_transfer.confirm.acknowledged")}
          />
        </Box>
        <Box display="flex" justifyContent="flex-end" pt={3}>
          <Box pr={1}>
            <Button
              color="primary"
              disabled={isSubmitting}
              onClick={handleClose}
            >
              <T keyName="common.action.cancel" />
            </Button>
          </Box>
          <Button
            variant="contained"
            color="primary"
            disabled={isSubmitting || !acknowledged}
            onClick={handleSubmit}
          >
            <T keyName="exhibitor.cart.bank_transfer.confirm.submit" />
          </Button>
        </Box>
      </FfairPaper>
    </FfairModal>
  );
};

export default ConfirmModal;
